import React from 'react'

import { Container } from '@components/Container'
import { Tabs } from '@components/Tabs/Tabs'
import { TabBody } from '@components/Tabs/components/TabBody'
import { ProfileHeader } from '@features/profile/components/ProfileHeader'
import { BookCollectionList } from '@features/myReading/components/BookCollectionList'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { ProfileWriting } from './components/ProfileWriting'
import { ProfilePenName } from './components/ProfilePenName'
import { UserMissionPage } from './components/UserMissionPage'
import { ProfileEbook } from './components/ProfileEbook'
import { MyProfilePageProps } from './interface'

export function MyProfilePage({
  user,
  profilePageSlug,
  handleActiveTabChange,
}: MyProfilePageProps) {
  return (
    <Container className='tablet-mobile:px-[20px] desktop-tablet:pt-[30px] desktop-tablet:pb-[80px]'>
      <ProfileHeader
        userId={user.id}
        profilePageSlug={profilePageSlug}
        bannerImgPath={user.bannerImgPath}
        avatarImgPath={user.avatarImgPath}
        displayName={user.displayName}
        username={user.username}
        aboutMe={user.aboutMe}
        facebookLink={user.facebookLink}
        twitterLink={user.twitterLink}
        totalFollowing={user.totalFollowing}
        totalFollower={user.totalFollower}
        totalWriting={user.totalBook}
        totalBookmark={user.totalBookshelf}
        totalReading={user.totalRead}
        isAdmin={user.isAdmin}
        allowSendMessage={user.allowSendMessage}
        canSetting
        email={user.email}
      />
      <Tabs
        id='my-profile'
        initialTabs={
          SHOW_EBOOK_FEATURE
            ? [
                {
                  tabId: 'writing',
                  name: 'งานเขียน (0)',
                },
                {
                  tabId: 'ebook',
                  name: 'อีบุ๊ก (0)',
                },
                {
                  tabId: 'penName',
                  name: 'นามปากกา (0)',
                },
                {
                  tabId: 'reward',
                  name: 'รางวัล',
                },
                {
                  tabId: 'bookList',
                  name: 'ลิสต์หนังสือ',
                },
              ]
            : [
                {
                  tabId: 'writing',
                  name: 'งานเขียน (0)',
                },
                {
                  tabId: 'penName',
                  name: 'นามปากกา (0)',
                },
                {
                  tabId: 'reward',
                  name: 'รางวัล',
                },
                {
                  tabId: 'bookList',
                  name: 'ลิสต์หนังสือ',
                },
              ]
        }
        onActiveTabChange={handleActiveTabChange}
      >
        <ProfileWriting />
        {SHOW_EBOOK_FEATURE && <ProfileEbook />}
        <ProfilePenName />
        <TabBody tabId='reward'>
          <UserMissionPage />
        </TabBody>
        <TabBody tabId='bookList'>
          <BookCollectionList />
        </TabBody>
      </Tabs>
    </Container>
  )
}
